// ── 미팅지도 설정: 배너 문구 패널 ────────────────────────────────────────────
// 동적관리 OperationsSettingsPanels.MeetingBannerSettings 이식 (2026-09-01 설정 이관).
// 상태·API 는 useMeetingMapSettings 로 이동, 기본값은 서버(ticketType.banner.js)와 통일.
import React from 'react';

export function SettingsBannerPanel({
  bannerPrefix, setBannerPrefix, bannerSuffix, setBannerSuffix,
  bannerLoading, bannerSaving, saveBanner,
}) {
  return (
    <div className="grid gap-3">
      <div>
        <span className="text-[12px] font-extrabold text-[var(--text)]">미팅지도 배너 문구</span>
        <div className="mt-0.5 text-[11px] text-[var(--text-muted)]">직원 미팅지도 상단에 보이는 오늘 미팅 문구입니다.</div>
      </div>
      {bannerLoading ? (
        <div className="text-[12px] font-semibold text-[var(--text-muted)]">불러오는 중입니다.</div>
      ) : (
        <>
          <div className="rounded-lg border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 px-3 py-2 text-center text-[12px] font-black text-blue-700 dark:text-blue-300">
            {bannerPrefix || '(앞 문구)'} 5건입니다. {bannerSuffix || ''}
          </div>
          <div className="grid gap-2 sm:grid-cols-2">
            <label className="grid gap-1">
              <span className="text-[11px] font-black text-[var(--text-muted)]">앞 문구</span>
              <input
                className="h-9 rounded-lg border border-[var(--border)] bg-[var(--bg-card)] px-3 text-[12px] font-bold text-[var(--text)] outline-none"
                value={bannerPrefix}
                onChange={(e) => setBannerPrefix(e.target.value)}
              />
            </label>
            <label className="grid gap-1">
              <span className="text-[11px] font-black text-[var(--text-muted)]">뒤 문구</span>
              <input
                className="h-9 rounded-lg border border-[var(--border)] bg-[var(--bg-card)] px-3 text-[12px] font-bold text-[var(--text)] outline-none"
                value={bannerSuffix}
                onChange={(e) => setBannerSuffix(e.target.value)}
              />
            </label>
          </div>
          <button
            onClick={saveBanner}
            disabled={bannerSaving}
            className="justify-self-end h-9 rounded-lg bg-slate-900 px-4 text-[12px] font-black text-white hover:bg-slate-800 dark:bg-accent-600 dark:hover:bg-accent-500 disabled:opacity-50"
          >
            {bannerSaving ? '저장 중...' : '저장'}
          </button>
        </>
      )}
    </div>
  );
}
